var _circle, _g, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16541_33526",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16541_33526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.60523 20.5C7.32598 20.5 7.09961 20.2597 7.09961 19.9633V19.4371C7.09961 18.2561 7.50077 16.1499 7.94702 15.2875C8.14824 14.8986 8.36694 14.5433 8.58056 14.2337C8.60817 14.1937 8.61827 14.1076 8.56145 14.0329C7.95774 13.239 7.59592 12.2282 7.59592 11.1292C7.59592 8.57192 9.55115 6.5 11.9617 6.5C14.3723 6.5 16.3276 8.57192 16.3276 11.1292C16.3276 12.1437 16.0192 13.0834 15.4965 13.8465C15.4449 13.922 15.4568 14.006 15.4857 14.0459C15.7405 14.3968 16.0092 14.8179 16.2522 15.2875C16.6985 16.1499 17.0996 18.2561 17.0996 19.4371V19.9633C17.0996 20.2597 16.9508 20.5013 16.6728 20.5H11.9617H7.60523Z",
    fill: "#474A60"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.25,
    stroke: "#474A60",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlaceholder);
export default __webpack_public_path__ + "static/media/user-placeholder.89adb8c3777b6244f199e4c8281a6717.svg";
export { ForwardRef as ReactComponent };